import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip, type TooltipProps } from '@mui/material';

interface InfoHintProps {
    /** One sentence. Why the control matters, or what the number means. */
    title: string;
    /** Which way it opens. `bottom` would drop into the field described. */
    placement?: TooltipProps['placement'];
}

/**
 * The explanation a warning or control needs but should not carry inline,
 * keeping the visible line to the shortest true statement.
 *
 * The icon swallows its own press and click: inside a `FormControlLabel` the
 * surrounding `<label>` would otherwise treat a click on it as a click on
 * the control, and over a draggable surface a press would start a drag.
 */
export default function InfoHint({ title, placement = 'top' }: InfoHintProps) {
    return (
        <Tooltip title={title} placement={placement}>
            <InfoOutlinedIcon
                tabIndex={0}
                role="button"
                aria-label={title}
                onPointerDown={(event) => event.stopPropagation()}
                onClick={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                }}
                fontSize="inherit"
                sx={{ ml: 0.5, verticalAlign: 'middle', opacity: 0.7 }}
            />
        </Tooltip>
    );
}
